module.exports = __webpack_public_path__ + "img/close_black.e724fec5.svg";